export default function (series) {
    var n = series.length, o = new Array(n);
    while (--n >= 0)
        o[n] = n;
    return o;
}
